import React from "react";
import { ArrowRight } from "lucide-react";
import { useCMS, useSectionEnabled } from "../context/CMSContext";

export default function SwitchCTA() {
  const enabled = useSectionEnabled("switchCTA");
  const { cms } = useCMS();
  if (!enabled) return null;
  const s = cms?.switchCTA || {};

  return (
    <section className="bg-white py-14 sm:py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="rounded-3xl bg-gradient-to-br from-[#FFFBF6] to-[#FFE6D6] p-8 sm:p-10 lg:p-14 text-center relative overflow-hidden">
          <div className="absolute -top-16 -right-16 w-64 h-64 rounded-full bg-[#FF6B3D]/15 blur-3xl" />
          <div className="relative">
            <h2 className="lm-section-title text-2xl sm:text-4xl lg:text-5xl">
              {s.title} <span className="lm-underline-swoosh">{s.highlight}</span>
            </h2>
            <p className="text-[#11151C]/70 mt-4 text-base sm:text-lg max-w-2xl mx-auto">{s.description}</p>
            <a
              href={s.ctaUrl || "#pricing"}
              className="lm-btn-primary mt-7 inline-flex items-center gap-2 px-6 py-3.5 rounded-xl font-bold text-sm"
            >
              {s.ctaText || "Get Started Now"} <ArrowRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
